<template>
  <Table
    ref="table"
    :statuses-items="tasksStatusesItems"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
  >
    <template v-slot:additionalTools="scope">
      <v-col style="flex-grow: 0" v-for="(select, idx) of selects" :key="idx">
        <table-select v-model="scope.filters.navbar_filter[select.name]" v-bind="select" @input="changeFilters()" />
      </v-col>
    </template>
  </Table>
</template>

<script>
import Table from '@/components/Table.vue';
import TableSelect from '@/components/TableSelect.vue';

import { call, get, sync } from 'vuex-pathify';

export default {
  name: 'TableTasks',
  components: {
    Table,
    TableSelect,
  },
  computed: {
    activeTool: sync('tools/activeTool'),
    currentLayerDataSourceName: sync('layers/currentLayer@data_source_name'),
    tasksCategories: get('tasks/tasksCategories'),
    tasksStatuses: get('admin/modulesMapping@tasks.statuses'),
    tasksLayerId: get('admin/modulesMapping@tasks.layer_id'),
    layersFilters: get('layers/layersFilters'),
    users: get('users/users'),
    usersArray() {
      return this.$_objectToArray(this.users);
    },
    customLayerData() {
      return {
        routeName: 'task',
        eventName: 'toggleTasks',
        filterEventName: 'toggleTasksFilter',
        layerId: this.tasksLayerId,
      };
    },
  },
  data: vm => ({
    selects: [
      {
        name: 'status',
        itemText: 'value',
        label: vm.$i18n.t('dialog.status'),
        items: [],
      },
      {
        name: 'assigned_user',
        itemText: 'name',
        itemValue: 'id',
        label: vm.$i18n.t('dialog.assignedPerson'),
        items: [],
      },
      {
        name: 'category',
        itemText: 'name',
        itemValue: 'name',
        label: vm.$i18n.t('dialog.category'),
        items: [],
      },
    ],
    tasksStatusesItems: [
      {
        key: 'new',
        color: 'rgba(0,145,234)',
        shadowColor: 'rgba(0,145,234,0.2)',
      },
      {
        key: 'done',
        color: 'rgba(24,128,56)',
        shadowColor: 'rgba(24,128,56,0.2)',
      },
      {
        key: 'in_progress',
        color: 'rgba(255,136,0)',
        shadowColor: 'rgba(255,136,0,0.2)',
      },
      {
        key: 'planned',
        color: 'rgba(108,108,108)',
        shadowColor: 'rgba(108,108,108,0.2)',
      },
      {
        key: 'unrealized',
        color: 'rgba(191,54,12)',
        shadowColor: 'rgba(191,54,12,0.2)',
      },
    ],
  }),
  methods: {
    getTasksCategories: call('tasks/getTasksCategories'),
    changeFilters() {
      this.$refs.table.handleFilter();
    },
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
    onLayerChanged() {
      this.$refs.table.onLayerChanged();
    },
    setFilters(additionalTableFilterValues, isInit) {
      setTimeout(() => {
        this.$refs.table.setNavbarFilters(additionalTableFilterValues, isInit);
      });
    },
    async init() {
      await this.getTasksCategories();
      this.selects.find(select => select.name === 'category').items = this.tasksCategories;
      const additionalTableFilterValues = this.$route.params.additionalTableFilterValues;
      if (additionalTableFilterValues) {
        this.setFilters(additionalTableFilterValues, true);
      }
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleTasks', false);
    });
  },
  created() {
    this.init();
    this.$root.$off('setAdditionalTableFilterValues');
    this.$root.$on('setAdditionalTableFilterValues', this.setFilters);
  },
  beforeMount() {
    this.selects.find(select => select.name === 'status').items = this.tasksStatusesItems.map(item => {
      item.value = this.tasksStatuses[item.key];
      return item;
    });
    this.selects.find(select => select.name === 'assigned_user').items = this.usersArray;
  },
};
</script>
